import { Card, CardContent, CardHeader, CardTitle } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";

import type { ReachabilityAgentTableProps } from "../types/reachability-analysis.types";

export function ReachabilityAgentTable({ rows, embedded = false }: ReachabilityAgentTableProps) {
    const { t } = useTranslation();

    const tableContent =
        rows.length === 0 ? (
            <p className="px-4 py-8 text-center text-sm text-muted-foreground">{t("reachability_analysis_no_data")}</p>
        ) : (
            <table className="w-full min-w-[640px] text-sm">
                <thead>
                    <tr className="border-b border-border/60 text-left text-xs text-muted-foreground">
                        <th className="px-4 py-3 font-medium">{t("agent")}</th>
                        <th className="px-4 py-3 font-medium text-right">{t("reachability_analysis_total_calls")}</th>
                        <th className="px-4 py-3 font-medium text-right">{t("reachability_analysis_reached")}</th>
                        <th className="px-4 py-3 font-medium text-right">{t("reachability_analysis_not_reached")}</th>
                        <th className="px-4 py-3 font-medium text-right">{t("answer_status_voicemail")}</th>
                        <th className="px-4 py-3 font-medium text-right">{t("reachability_analysis_reach_rate")}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.agentId} className="border-b border-border/40 last:border-b-0">
                            <td className="px-4 py-3 font-medium">{row.agentLabel}</td>
                            <td className="px-4 py-3 text-right tabular-nums">{row.total}</td>
                            <td className="px-4 py-3 text-right tabular-nums">{row.reached}</td>
                            <td className="px-4 py-3 text-right tabular-nums">{row.not_reached}</td>
                            <td className="px-4 py-3 text-right tabular-nums">{row.voicemail}</td>
                            <td className="px-4 py-3 text-right tabular-nums">{row.reach_rate.toFixed(1)}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );

    if (embedded) {
        return (
            <div className="min-h-0">
                <p className="mb-2 text-sm font-medium">{t("reachability_analysis_agent_table_title")}</p>
                <div className="overflow-x-auto">{tableContent}</div>
            </div>
        );
    }

    return (
        <Card className="border-border/60 shadow-none">
            <CardHeader className="pb-2">
                <CardTitle className="text-base">{t("reachability_analysis_agent_table_title")}</CardTitle>
            </CardHeader>
            <CardContent className="overflow-x-auto p-0">{tableContent}</CardContent>
        </Card>
    );
}
